import { bulkUpdateProjectItems } from '@wix/ambassador-portfolio-project-items-v1-project-item/http';
import { bulkUpdateProjects } from '@wix/ambassador-portfolio-projects-v1-project/http';
import { chunk as getChunks } from 'lodash';
import { fetchPortfolio } from '../new-infra-fetchers/portfolio-projects/fetch-portfolio';
import { buildPortfolioBulkUpdatePayload } from './build-payloads/bulk-update-portfolio-alt-text-payload';
const BULK_LIMIT = 100;
const updateProjectItemMethod = async (httpClient, errorHandler, request) => {
  const {
    withErrorHandler
  } = errorHandler;
  const {
    data
  } = await withErrorHandler(async () => httpClient.request(bulkUpdateProjectItems(request)), {
    errorCodesMap: {}
  });
  return {
    success: !!data
  };
};
const updateProjectMethod = async (httpClient, errorHandler, request) => {
  const {
    withErrorHandler
  } = errorHandler;
  const {
    data
  } = await withErrorHandler(async () => httpClient.request(bulkUpdateProjects(request)), {
    errorCodesMap: {}
  });
  return {
    success: !!data
  };
};
export const updatePortfolioAltText = async (httpClient, errorHandler, altTextData) => {
  const {
    getResolvedError
  } = errorHandler;
  const entityIdsList = altTextData.map(item => item.entityId).filter(entityId => entityId !== undefined);
  try {
    const portfolioProjects = await fetchPortfolio(httpClient, errorHandler, entityIdsList);
    const allFailedElements = [];
    const chunks = getChunks(altTextData, BULK_LIMIT);
    const portfolioProjectsMap = new Map(portfolioProjects.map(portfolioProject => [portfolioProject.project.id, portfolioProject]));
    const updatePromises = chunks.map(async chunk => {
      const payload = buildPortfolioBulkUpdatePayload(chunk, portfolioProjectsMap);
      const {
        items,
        projects
      } = payload;
      if (items.length === 0 && projects.length === 0) {
        return {
          failedElements: chunk,
          success: false
        };
      }
      const itemsPromises = items.map(request => updateProjectItemMethod(httpClient, errorHandler, request));
      const projectsPromise = updateProjectMethod(httpClient, errorHandler, {
        projects,
        returnFullEntity: false
      });
      const chunkPromises = [...itemsPromises, projectsPromise];
      const results = await Promise.all(chunkPromises);
      const success = results.every(result => result.success);
      if (!success) {
        const failedIndexes = (results ?? []).map((_item, index) => index).filter(index => index !== undefined);
        const failedElementsChunk = chunk.filter((_, index) => failedIndexes.includes(index));
        allFailedElements.push(...failedElementsChunk);
      }
      return {
        success
      };
    });
    const results = await Promise.all(updatePromises);
    const overallSuccess = results.every(result => result.success);
    return {
      failedElements: allFailedElements,
      success: overallSuccess
    };
  } catch (error) {
    return {
      errorMessage: getResolvedError(error).message,
      failedElements: altTextData,
      success: false
    };
  }
};
//# sourceMappingURL=update-portfolio-alt-text.js.map